import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NbContextMenuModule, NbButtonModule, NbIconModule, NbMenuModule } from '@nebular/theme';
import { TranslateModule } from '@ngx-translate/core';
import { KontaktMenuComponent } from './kontakt-menu.component';

@NgModule({
  declarations: [
    KontaktMenuComponent,
  ],
  exports: [
    KontaktMenuComponent,
  ],
  imports: [
    CommonModule,
    NbMenuModule,
    NbContextMenuModule,
    NbButtonModule,
    NbIconModule,
    TranslateModule,
  ],
})
export class KontaktMenuModule { }
